import React from 'react';
import PropTypes from 'prop-types';
import Paper from '@material-ui/core/Paper';

const styles = {
  message: {
    color: '#fff',
    fontSize: '14px',
    backgroundColor: '#0baf26',
    padding: '1px',
    marginTop: '10px',
    marginBottom: '15px',
  },
};

function SuccessMessage(props) {
  if (props.message) {
    return (
      <Paper style={styles.message} elevation={2}>
        <p>{props.message}</p>
      </Paper>
    );
  } else {
    return null;
  }
}

SuccessMessage.propTypes = {
  message: PropTypes.string,
};

export default SuccessMessage;
